import { Colors } from "@brg/ui"
import { LayoutConst } from "core"
import styled from "styled-components"
import { QueueMode } from "../../QueueNew"

export const QueueLineWrapper  = styled.div<{
    mode: QueueMode
}>`
    width: 100%;
    height: 2px;
    // margin-top: ${p => p.mode === QueueMode.create ? "148px" : "88px"};
    margin-top: ${p => p.mode === QueueMode.create ? "148px" : "48px"};
    margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "0px"};
    background-color: ${Colors.galBlack10};
    border-radius: 10px;
    position: relative;

   @media screen and (max-width: ${LayoutConst.screen.l}px) {
        // margin-top: ${p => p.mode === QueueMode.create ? "148px" : "108px"};
        margin-top: ${p => p.mode === QueueMode.create ? "148px" : "48px"};
        margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "0"};
    }

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
      margin-top: ${p => p.mode === QueueMode.create ? "148px" : "42px"};
    }
  
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        margin-top: ${p => p.mode === QueueMode.create ? "0px" : "10px"};
        margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "36px"};

        display: flex;
        flex-direction: column;
        align-items: center;
    }
`

export const QueueDescription = styled.div`
  color: ${Colors.galBlack73};
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 15px;
    line-height: 20px; 
  }
`
export const QueueNumber = styled.div`
  color: ${Colors.galBlack100};
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; 
  letter-spacing: -0.02em;

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 17px;
    line-height: 22px; 
  }
`

export const MoreButton = styled.img`
    width: 24px;
    height: 24px;
    position: absolute;
    top: 24px;
    right: 24px;
`
import { Colors } from "@brg/ui"
import { LayoutConst } from "core"
import styled from "styled-components"
import { QueueMode } from "../../QueueNew"

export const QueueLineWrapper  = styled.div<{
    mode: QueueMode
}>`
    width: 100%;
    height: 2px;
    // margin-top: ${p => p.mode === QueueMode.create ? "148px" : "88px"};
    margin-top: ${p => p.mode === QueueMode.create ? "148px" : "48px"};
    margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "0px"};
    background-color: ${Colors.galBlack10};
    border-radius: 10px;
    position: relative;

   @media screen and (max-width: ${LayoutConst.screen.l}px) {
        // margin-top: ${p => p.mode === QueueMode.create ? "148px" : "108px"};
        margin-top: ${p => p.mode === QueueMode.create ? "148px" : "48px"};
        margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "0"};
    }

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
      margin-top: ${p => p.mode === QueueMode.create ? "148px" : "42px"};
    }
  
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        margin-top: ${p => p.mode === QueueMode.create ? "0px" : "10px"};
        margin-bottom: ${p => p.mode === QueueMode.create ? "0px" : "36px"};

        display: flex;
        flex-direction: column;
        align-items: center;
    }
`

export const QueueDescription = styled.div`
  color: ${Colors.galBlack73};
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 15px;
    line-height: 20px; 
  }
`
export const QueueNumber = styled.div`
  color: ${Colors.galBlack100};
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; 
  letter-spacing: -0.02em;

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 17px;
    line-height: 22px; 
  }
`

export const MoreButton = styled.img`
    width: 24px;
    height: 24px;
    position: absolute;
    top: 24px;
    right: 24px;
`
